<template>
  <div>
    <b-modal
      size="lg"
      centered
      id="modal-edit-product"
      hide-footer
      header-class="no-border"
      body-class="no-border"
      modal-class="modalStyle"
      ref="modal-edit-product"
    >
      <div class="modalBody">
        <b-row class="imageArea">
          <label for="image" class="cursor">
            <div>
              <div v-if="!imageSelected">
                <img
                  v-if="this.product.image"
                  :src="this.product.image"
                  alt="Produto"
                  style="cursor: pointer"
                  class="container-image-product"
                />
                <div v-else class="btn-addImage">
                  <b-icon icon="card-image" font-scale="4.5"></b-icon>
                  <span>Adicionar Imagem</span>
                </div>
              </div>
              <div v-else>
                <img
                  :src="imagePreview"
                  alt="Produto"
                  style="cursor: pointer"
                  class="container-image-product"
                />
              </div>
            </div>
          </label>
          <div class="image">
            <b-form-file
              name="image"
              id="image"
              class="arquivo"
              accept="image/*"
              @change="selectImage"
              ref="imageInput"
            />
          </div>
          <div @click="limparImagem" class="cursor">
            <b-icon-trash-fill></b-icon-trash-fill>
          </div>
        </b-row>
        <b-row class="formsArea">
          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Nome</label>
            <b-form-input
              type="text"
              id="input-type"
              v-model="product.type"
              :state="validateState('type')"
              aria-describedby="input-1-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback"
              >Campo obrigatório</b-form-invalid-feedback
            >
          </b-form>

          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Descrição</label>
            <b-form-textarea
              rows="4"
              type="text"
              class="input-description"
              v-model="product.description"
              :state="validateState('description')"
              aria-describedby="input-2-live-feedback"
            ></b-form-textarea>
            <b-form-invalid-feedback id="input-2-live-feedback"
              >Campo obrigatório</b-form-invalid-feedback
            >
          </b-form>

          <div>
            <b-form @submit.prevent="handleSubmit">
              <b-row>
                <b-col sm="4">
                  <label class="mt-3 labels">Kilogramas</label>
                  <b-form-input
                    type="number"
                    id="input-quantity-kg"
                    v-model="product.quantity_kg"
                    step="0.01"
                    :state="validateState('quantity_kg')"
                    aria-describedby="input-1-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback"
                    >Campo não pode ser negativo</b-form-invalid-feedback
                  >
                </b-col>

                <b-col sm="4">
                  <label class="mt-3 labels">Bandeijas</label>
                  <b-form-input
                    type="number"
                    id="input-quantity-plate"
                    v-model="product.quantity_plate"
                    step="0.01"
                    :state="validateState('quantity_plate')"
                    aria-describedby="input-2-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-2-live-feedback"
                    >Campo não pode ser negativo</b-form-invalid-feedback
                  >
                </b-col>

                <b-col sm="4">
                  <label class="mt-3 labels">Unidades</label>
                  <b-form-input
                    type="number"
                    id="input-quantity-unity"
                    v-model="product.quantity_unity"
                    :state="validateState('quantity_unity')"
                    aria-describedby="input-3-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-3-live-feedback"
                    >Campo não pode ser negativo</b-form-invalid-feedback
                  >
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-row>
      </div>

      <div class="modalFooter">
        <b-row class="alinhamentoLinha">
          <b-button class="button btn-cancel" @click="openModal(false)"
            >Cancelar</b-button
          >
          <b-button
            class="button btn-save"
            type="submit"
            variant="primary"
            @click="handleSubmit"
            >Salvar</b-button
          >
        </b-row>
      </div>
    </b-modal>
    <ModalConfirmation
      :isConfirm="isConfirm"
      @responseModal="responseModal($event)"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ModalConfirmation from '../ModalConfirmation.vue';
import { EditProduct, EditProductImage } from '../../services/Products';
import showError from '../../utils/showError';

export default {
  components: { ModalConfirmation },
  mixins: [validationMixin],
  data() {
    return {
      isConfirm: true,
      nomeImagem: null,
      imageSelected: false,
      imagePreview: null,
      product: {
        id: null,
        type: null,
        description: null,
        image: null,
        quantity_kg: null,
        quantity_plate: null,
        quantity_unity: null,
      },
    };
  },
  validations: {
    product: {
      type: {
        required,
      },
      description: {
        required,
      },
      quantity_kg: {
        required,
      },
      quantity_plate: {
        required,
      },
      quantity_unity: {
        required,
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$v.product.$touch();
      if (this.$v.product.$anyError) {
        return;
      }
      this.openModal(true);
    },
    openModal(isConfirm) {
      this.isConfirm = isConfirm;
      this.$bvModal.show('modal-confirmation');
    },
    async responseModal(event) {
      if (event) {
        try {
          await EditProduct(this.product.id, {
            type: this.product.type,
            description: this.product.description,
            quantity_kg: this.product.quantity_kg,
            quantity_plate: this.product.quantity_plate,
            quantity_unity: this.product.quantity_unity,
          });

          if (this.imageSelected || this.product.image == null) {
            const formImage = new FormData();
            formImage.append('image', this.product.image);
            await EditProductImage(this.product.id, formImage)
              .then(() => {
                this.$toasted.global.defaultSuccess();
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch(showError);

            // Recarrega a página somente após o upload da imagem
          } else {
            this.$toasted.global.defaultSuccess();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        } catch (error) {
          showError(error);
        }
      }
      this.$bvModal.hide('modal-confirmation');
      this.$bvModal.hide('modal-edit-product');
      setTimeout(() => {
        this.$router.go(0);
      }, 1000);
    },
    selectImage(event) {
      const image = event.target.files[0];
      this.nomeImagem = image.name;
      this.product.image = image;

      if (this.product.image) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(image);
        this.imageSelected = true;
      }
    },
    limparImagem() {
      this.product.image = null;
      this.nomeImagem = null;
      this.imagePreview = null;
      this.imageSelected = false;
    },
    validateState(type) {
      const { $dirty, $error } = this.$v.product[type];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.product = {
        type: null,
        description: null,
        image: null,
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.$bvModal.hide('modalEditProduct');
    },
  },
};
</script>

<style lang="scss" scoped>
.img-preview-product {
  width: 100%;
  height: 100%;
}
.container-image-product {
  height: 193px;
  width: 150px;
  border-radius: 8px;
  background-color: #fff;

  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .no-border {
  border: none;
}
::v-deep .modalStyle > .modal-dialog > .modal-content {
  background-color: #be8250;
  border-radius: 20px;
  color: #eeeeee;
}
.modalBody {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 20px;
}

.imageArea {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.cursor {
  cursor: pointer;
}

.icon {
  margin-top: 25vh;
  margin-left: -6vw;
}

.horizontal-inputs {
  margin-bottom: 20px;
}
.btn-addImage {
  background-color: #eeeeee;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  color: #be8250;
  padding: 1rem;
  height: 193px;
  width: 150px;
}
.arquivo {
  display: none;
}
.selectedImage {
  text-align: center;
}

.formsArea {
  display: inline;
  padding-right: 25px;
  margin-top: -20px;
}
.form-control {
  background-color: #eeeeee;
  border-radius: 11px;
}

.modalFooter {
  margin-top: 30px;
}
.alinhamentoLinha {
  display: flex;
  justify-content: flex-end;
  margin-right: 0.5rem !important;
}
.button {
  height: 32px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 22px;
  border: none;
  width: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-cancel {
  background-color: #d12c38;
}
.btn-save {
  background-color: #169933;
  margin-left: 18px;
}
</style>
